if (!customElements.get("lsg-article-dropdown")) {
  class LSGArticlesDropdown extends HTMLElement {
    constructor() {
      super();

      // Defining variables
      this.dropdown = document.querySelector(
        ".lsg-blog-recipe-list__navigation-btn"
      );
      this.classes = {
        content: "js-dropdown-nav-content",
        element: "js-dropdown-nav-el",
      };
    }

    /**
     * Lifecycle method called when element is clicked
     *
     * @returns {void}
     */
    connectedCallback() {
      this.dropdown.addEventListener("click", (e) =>
        this.handleDropdown(e.target)
      );
    }

    /**
     * Handle dropdown click event
     *
     * @param {HTMLElement} dropdown - The clicked dropdown element.
     */
    handleDropdown(dropdown) {
      const content = this.querySelector(`.${this.classes.content}`);
      const element = this.querySelector(`.${this.classes.element}`);

      // Ensure that the content and element exist
      if (content) content.classList.toggle("visible");
      if (element) element.classList.toggle("show");
    }
  }

  customElements.define("lsg-article-dropdown", LSGArticlesDropdown);
}
